import React, { useState, useEffect } from 'react';
import { Terminal, Clock } from 'lucide-react';
import './DiscordStatus.css';

function DiscordStatus() {
    const [data, setData] = useState(null);
    const [elapsed, setElapsed] = useState("");
    const DISCORD_ID = "836647735809146930";

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const res = await fetch(`https://api.lanyard.rest/v1/users/${DISCORD_ID}`);
                const json = await res.json();
                if (json.success) setData(json.data);
            } catch (e) { console.error(e); }
        };
        fetchStatus();
        const interval = setInterval(fetchStatus, 3000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            const act = data?.activities?.find(a => a.type === 0);
            if (act?.timestamps?.start) {
                const diff = Date.now() - act.timestamps.start;
                const h = Math.floor(diff / 3600000);
                const m = Math.floor((diff % 3600000) / 60000);
                const s = Math.floor((diff % 60000) / 1000);
                setElapsed(`${h > 0 ? h + ":" : ""}${m < 10 && h > 0 ? "0" + m : m}:${s < 10 ? "0" + s : s}`);
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [data]);

    const getAssetUrl = (appId, assetId) => {
        if (!assetId) return null;
        if (assetId.startsWith("mp:external")) {
            return `https://media.discordapp.net/external/${assetId.split('https/')[1]}`;
        }
        return `https://cdn.discordapp.com/app-assets/${appId}/${assetId}.png`;
    };

    if (!data) return null;
    const act = data.activities?.find(a => a.type === 0);

    return (
        <div className="discord-activity-card">
            <div className="ds-header-mini">
                <Terminal size={12}/> {act ? act.name.toUpperCase() : "ACTIVITY"}
            </div>

            {act ? (
                <div className="activity-layout">
                    <div className="activity-images">
                        <img
                            src={getAssetUrl(act.application_id, act.assets?.large_image)}
                            alt="Large" className="large-asset"
                            title={act.assets?.large_text || act.name}
                            onError={(e) => e.target.style.opacity = '0'}
                        />
                        {act.assets?.small_image && (
                            <img
                                src={getAssetUrl(act.application_id, act.assets.small_image)}
                                alt="Small" className="small-asset"
                                title={act.assets?.small_text || "Status"}
                            />
                        )}
                    </div>
                    <div className="activity-text-content">
                        <div className="act-name">{act.name}</div>
                        <div className="act-details">{act.details || ""}</div>
                        <div className="act-state">{act.state || ""}</div>
                        <div className="act-timer"><Clock size={12}/> {elapsed || "00:00"} elapsed</div>
                    </div>
                </div>
            ) : <p className="no-activity">No active session detected</p>}
        </div>
    );
}

export default DiscordStatus;